export const EXCMCAR_SHOW_RESET = 'EXCMCAR_SHOW_RESET'
export const EXCMCAR_SHOW_SET_ERROR = 'EXCMCAR_SHOW_SET_ERROR'
export const EXCMCAR_SHOW_SET_RETRIEVED = 'EXCMCAR_SHOW_SET_RETRIEVED'
export const EXCMCAR_SHOW_TOGGLE_LOADING = 'EXCMCAR_SHOW_TOGGLE_LOADING'
